import { createApp } from "vue";

// Application bootstrapper component
import AppRoot from "@/components/AppRoot.vue";

// Modules
import dialogs from "@/common/dialogs";
import store from "@/store";
import i18n from "@/localization";
import router from "@/router";
import { declareGlobalComponents } from "@/common/global_components";
import toaster from "@/common/toaster";
// import "@/common/dialogs";

// Styles
import "@bi-book/bibook-ui-kit/dist/main.css";
import "@bi-book/bibook-ui-kit/src/assets/fonts/open-sans/index.scss";
import "@/assets/stylesheet/application.scss";
import "@mdi/font/css/materialdesignicons.min.css";

export const app = createApp(AppRoot);

app.use(dialogs);
app.use(router);
app.use(store);
app.use(i18n);
app.use(toaster);

declareGlobalComponents(app);
